import React from 'react';
import type { FC } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'antd';
import { type FormFieldType } from '../../../../../constants/Interfaces/FormFieldTypes';
import { solmanStagingFormFields } from '../../../../../constants/FormFields/AdminForm/solmanConfigFormFields';
import { LabelValueWrapper, LabelWrapper } from '../../../../../assets/styles/commonStyled';
import { SummaryViewRow } from '../style';
import { getLabelValueFormatter } from '../../../../../helpers/commonHelper';

interface ConfigSummaryProps {
  data?: Partial<Record<string, string>>
}

const SolmanConfigSummary: FC<ConfigSummaryProps> = ({ data }) => {
  return (
    <>
      <SummaryViewRow
        gutter={[16, 8]}
      >
        {solmanStagingFormFields.map((formField: FormFieldType) => {
          return (
            <Col key={formField.id} xs={24} md={8} xxl={7}>
              <LabelWrapper>{formField.label}</LabelWrapper>
              <LabelValueWrapper>
                {getLabelValueFormatter(data?.[formField.name], formField?.type)}
              </LabelValueWrapper>
            </Col>
          );
        })}
      </SummaryViewRow>
    </>
  );
};

SolmanConfigSummary.propTypes = {
  data: PropTypes.object
};

export default SolmanConfigSummary;
